import { createFileRoute } from '@tanstack/react-router';
import { SyncSendPage } from '@features/admin/sync-send';

/** Bez filtrů a bez načítání v `beforeLoad` — stránka jen odesílá, nic netahá. */
export const Route = createFileRoute('/admin/sync-send/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <SyncSendPage />;
}
